module.exports = __webpack_public_path__ + "static/media/img-about-usp2-mobile.03d000ee.jpg";